module.exports = __webpack_public_path__ + "img/4.d8a4419d.svg";